import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SkeletonLoaderComponent } from './../../components/skeleton-loader/skeleton-loader.component';

@Component({
  selector: 'app-datatable',
  standalone: true,
  imports: [CommonModule, SkeletonLoaderComponent],
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
})
export class DatatableComponent  {
  @Input() loading = false;
  
  trackByIndex(i: number) { return i; }
}